module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "schedule-table"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.schedule), function(game, index) {
    return _c('tr', {
      key: ("game-" + index)
    }, [_c('td', [_c('span', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("localDate")(game.date)))])]), _vm._v(" "), _c('td', {
      staticClass: "duration cell-number"
    }, [_c('span', {
      staticClass: "fa fa-clock-o"
    }), _vm._v("\n              " + _vm._s(_vm._f("durationToHours")(game.duration)) + "\n            ")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "fa fa-gamepad"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(game.name))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(game.year))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(game.platform))])]), _vm._v(" "), _c('td', [(game.notes) ? [_c('span', {
      staticClass: "fa fa-comment"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(game.notes))])] : _vm._e()], 2), _vm._v(" "), (game.donation_total && game.donation_total.length > 0) ? [_c('td', {
      staticClass: "donation_total"
    }, [_c('span', {
      staticClass: "fa fa-arrow-up"
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(("$" + (game.donation_total.join('<br/><br/> $'))))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "donation_unlock"
    }, [_c('span', {
      staticClass: "fa fa-comments"
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(game.donation_unlock.join('<br/><br/>'))
      }
    })])] : _c('td', {
      staticClass: "no-padding",
      attrs: {
        "colspan": "2"
      }
    })], 2)
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-spaced"
  }, [_vm._v("Schedule")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("The schedule below is auto adjusted to your timezone")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('abbr', {
    attrs: {
      "title": "Estimated"
    }
  }, [_vm._v("Est.")]), _vm._v(" Date\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "duration"
  }, [_c('abbr', {
    attrs: {
      "title": "Estimated"
    }
  }, [_vm._v("Est.")]), _vm._v(" Duration\n            ")]), _vm._v(" "), _c('th', [_vm._v("Game")]), _vm._v(" "), _c('th', [_vm._v("Year")]), _vm._v(" "), _c('th', [_vm._v("Platform")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8aa671c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleView/index.vue
// module id = 236
// module chunks = 1